export const ACTIONS_TRANSLATE = {
    actions: {
        create: "Create",
        add: "Add",
        import: "Import",
        save: "Save",
        back: "Back",
        print: "Print",
        continue: "Continue",
        copy: "Copy",
        ok: "Ok"
    }
};
